<div class="appver">
  <p>{{ this.appVersion }}</p>
  <p *ngIf="updateAvailable"><b>There are updates available!</b> <button (click)="triggerUpdate()">Update</button></p>
  <p><a [routerLink]="['/discover']">Back</a></p>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/version/version.component.html